import * as tslib_1 from "tslib";
import React from 'react';
import requestAnimationFrame from '../utils/requestAnimationFrame';
import withScrollableContainer from '../decorators/withScrollableContainer';
var ScrollAware = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollAware, _super);
    function ScrollAware() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            scrollTop: 0,
            bodyWidth: 0,
            scrollHeight: 0,
        };
        _this.handleScroll = function () {
            return requestAnimationFrame(function () {
                return _this.setState({
                    scrollTop: _this.props.getScrollTop(),
                    scrollHeight: _this.props.getScrollHeight(),
                    bodyWidth: (_this.props.getScrollableContainerOrBody() || { clientWidth: 0 }).clientWidth,
                });
            });
        };
        return _this;
    }
    ScrollAware.prototype.componentDidMount = function () {
        var scrollableElement = this.props.getScrollableContainerOrWindow();
        scrollableElement &&
            scrollableElement.addEventListener('scroll', this.handleScroll);
    };
    ScrollAware.prototype.componentWillUnmount = function () {
        var scrollableElement = this.props.getScrollableContainerOrWindow();
        scrollableElement &&
            scrollableElement.removeEventListener('scroll', this.handleScroll);
    };
    ScrollAware.prototype.render = function () {
        return this.props.children(this.state);
    };
    return ScrollAware;
}(React.Component));
export default withScrollableContainer(ScrollAware);
//# sourceMappingURL=ScrollAware.js.map